import React from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../../components/Icon";
import { downloadContract } from "../../../../../../services/contract.service";
import { toast } from "react-toastify";

const Control = ({
  className,
  item, // Contrat à télécharger
}) => {

  // Fonction de téléchargement du contrat en mode blob
  const handleDownload = async () => {
    if (!item) {
      toast.error("Impossible de télécharger : aucun contrat fourni");
      return;
    }

    try {
      // Utiliser le service de téléchargement qui utilise le mode blob
      await downloadContract(item);
    } catch (error) {
      console.error("Erreur lors du téléchargement du contrat:", error);
      toast.error("Erreur lors du téléchargement du contrat");
    }
  };
  
  const actions = [
    {
      icon: "download",
      title: "Télécharger le document",
      action: () => handleDownload(),
    }
  ];

  return (
    <div className={cn(styles.control, className)}>
      {actions.map((x, index) => (
        <button 
          className={cn(styles.button, x.className)} 
          key={index} 
          onClick={x.action} 
          disabled={x.disabled}
          title={x.title}
        >
          <Icon name={x.icon} size="20" />
        </button>
      ))}
    </div>
  );
};

export default Control;
